import { Injectable } from '@angular/core';
import { category } from '@reflact/ipkv-types';

@Injectable({
  providedIn: 'root'
})
export class Kategorie {
  public selectedKategorie: category | null = null;
}